import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private componentWithUnsavedChanges: any = null;

  register(component: any) {
    this.componentWithUnsavedChanges = component;
  }

  unregister() {
    this.componentWithUnsavedChanges = null;
  }

  getComponent() {
    return this.componentWithUnsavedChanges;
  }
}
